// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__19kLB","content":"styles_content__z9Xp5","selectAll":"styles_selectAll__2mlvs"};